export const routes = {
  BILLING: '/billing',
  CALENDAR: '/calendar',
  CASES: '/cases',
  CLIENTS: '/clients',
  DASHBOARD: '/',
  HELP: '/help',
  LOGIN: '/login',
  PROFILE: '/profile',
  RESEARCH: '/research',
  SETTINGS: '/settings',
  SIGNUP: '/signup',
  TEAM: '/team',
}
